import { PaccApplyResultRs, PaccUnreliableResultDto } from '@domain/rs/phs/pacc/results/PaccApplyResultRs';
import { ResultType } from '@domain/constant/resultType';
import { ModuleType } from '@domain/constant/moduleType';

export class PaccUnreliableResultVO {
  module: ModuleType;
  unreliableYn: boolean;

  constructor(rs: PaccUnreliableResultDto) {
    this.module = rs.module;
    this.unreliableYn = rs.unreliableYn;
  }
}

export class PaccApplyResultVO {
  userName: string;
  resultType: ResultType;
  moduleResults: PaccUnreliableResultVO[] | null;

  constructor(rs: PaccApplyResultRs) {
    this.userName = rs.userName;
    this.resultType = rs.resultType;
    this.moduleResults = rs.moduleResults?.map((moduleResult) => new PaccUnreliableResultVO(moduleResult));
  }
}
